var _style, _g, _g2, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _g3, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpidIdpTeamsystemid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219.2 30",
    style: {
      enableBackground: "new 0 0 219.2 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#0090D1;}\n\t.st2{fill:none;stroke:#0090D1;stroke-miterlimit:10;}\n\t.st3{fill:#0090D1;stroke:#0090D1;stroke-width:0.3;stroke-miterlimit:10;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000133487098117880910290000005724759471769617063_);fill:url(#SVGID_00000119796250500852993160000012700664519295070121_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000171718025371366103600000013126621550853174913_);fill:url(#SVGID_00000000219594378441445890000002404049244088866972_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000090279921607307402700000015948709686229808518_);fill:url(#SVGID_00000095319389402680818750000003241865843864839860_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000115498425241593638850000000462949633581221294_);fill:url(#SVGID_00000007426582632593461130000007614657255122612643_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000107590624900073826070000018237020667454022558_);fill:url(#SVGID_00000055665856015188284250000002841184200773674901_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000068636014668072431900000001843995982696346046_);fill:url(#SVGID_00000129189393481203215950000017994868679553377181_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000110431429662464524830000007145976179065214373_);fill:url(#SVGID_00000104679131803436834120000015015502035762179752_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000160155924072516481850000005314106354803135379_);fill:url(#SVGID_00000131342676767950283920000009049908015885989548_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000091002810046255775500000002921771924551141801_);fill:url(#SVGID_00000049215384130010171940000002699532587897710512_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000168099896941413748740000013656928941556947124_);fill:url(#SVGID_00000155848371908808281940000011964003223165120918_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000173863094193522995940000005416442639032512902_);fill:url(#SVGID_00000013159118689180233510000011929444875067725207_);}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000122703223084562760820000014031733021537737113_);fill:url(#SVGID_00000078013213881836487680000006403733807591101112_);}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000088117037981360934640000014113943421369738674_);fill:url(#SVGID_00000025442441712104107240000012268760179308704904_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000039828356498581988590000006730245541844260485_);fill:url(#SVGID_00000048472008005725650860000000115566521082848436_);}\n\t.st18{fill:#2B66AE;}\n\t.st19{fill:#2965AE;}\n\t.st20{fill:none;stroke:#0E8FCF;stroke-width:2.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,9.2h1.8v14h-1.8V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.9,9.2c4.5,0,6.9,2.3,6.9,7c0,4.9-2.4,7-7.2,7h-3.8v-14H156.9z M154.6,10.9v10.8h2.4 c3.5,0,4.9-1.8,4.9-5.4c0-3.5-1.4-5.4-4.9-5.4H154.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.9,9.2h1.8v14h-1.8V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.9,9.2c4.5,0,6.9,2.3,6.9,7c0,4.9-2.4,7-7.2,7h-3.8v-14H156.9z M154.6,10.9v10.8h2.4 c3.5,0,4.9-1.8,4.9-5.4c0-3.5-1.4-5.4-4.9-5.4H154.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "44.9,10.9 44.9,10.8 44.9,9.1 44.9,9.1 44.8,9.1 34.5,9.1 34.4,9.1 34.4,9.1 34.4,10.8 34.4,10.9  34.5,10.9 38.7,10.9 38.7,23.2 38.7,23.3 38.8,23.3 40.6,23.3 40.6,23.3 40.6,23.2 40.6,10.9 44.8,10.9  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.7,12.6c-2.9,0-4.7,2.2-4.7,5.5c0,3.4,1.7,5.4,4.8,5.4c1.5,0,2.8-0.5,3.9-1.4h0.1V22l-0.7-1.2v-0.1 L52,20.8c-1.1,0.7-2,1.1-3,1.1c-2.3,0-2.9-1.7-2.9-3.2h6.6h0.1v-0.1c0-0.2,0-0.7,0-0.9C52.8,14.3,51.4,12.6,48.7,12.6 M45.9,17.1 c0.1-0.6,0.4-2.9,2.8-2.9c1.5,0,2.3,1,2.3,2.9H45.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.7,12.6c-1.4,0-2.9,0.6-3.9,1.5l-0.1,0.1v0.1l0.8,1.1v0.1h0.1c0.9-0.7,1.7-1.1,2.9-1.1 c1.3,0,2.1,0.8,2.1,2.1v0.9c-0.5-0.1-1-0.1-1.5-0.1c-4.3,0-4.8,2.3-4.8,3.3c0,1.9,1.2,3.1,3.1,3.1c1.5,0,2.6-0.6,3.3-1.8l0.1,1.5 v0.1h0.1h1.4h0.1v-0.3v-6.9C62.5,13.9,61.1,12.6,58.7,12.6 M60.6,18.7V19c0,1.3-1.2,2.9-2.7,2.9c-1.1,0-1.7-0.5-1.7-1.5 c0-1.3,0.9-1.9,2.9-1.9C59.9,18.7,60.3,18.7,60.6,18.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.5,12.6c-1.5,0-2.5,0.8-3.2,1.6c-0.4-1.1-1.2-1.6-2.5-1.6c-1.2,0-2.2,0.5-3.1,1.6l-0.1-1.3v-0.1h-0.1H65 h-0.1v0.1v10.3v0.1H65h1.7h0.1v-0.1v-7.4c0.6-0.7,1.5-1.5,2.5-1.5s1.4,0.6,1.4,2.1v6.8v0.1h0.1h1.7h0.1v-0.1v-7.4 c0.6-0.7,1.4-1.4,2.4-1.4s1.4,0.6,1.4,2v6.8v0.1h0.1h1.7h0.1v-0.1v-7.1C78.3,13.8,77.4,12.6,75.5,12.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86,15.2c-2.3-0.8-3.4-1.2-3.4-2.7c0-1.3,1-2,2.6-2c1.3,0,2.5,0.6,3.4,1.6l0.1,0.1l0.1-0.1l1-1.1v-0.1v-0.1 c-1.2-1.4-2.7-2-4.6-2c-2.8,0-4.6,1.5-4.6,3.9c0,2.1,1.1,3.1,4.2,4.1c2.5,0.8,3.1,1.3,3.1,2.7c0,1.4-1.1,2.3-2.8,2.3 c-1.3,0-2.6-0.6-3.9-1.8l-0.1-0.1L81,20l-1,1.2v0.1v0.1c1.3,1.4,3.1,2.2,5,2.2c2.9,0,4.8-1.6,4.8-4.2C89.8,17.2,88.9,16.2,86,15.2 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.6,12.9L97.6,12.9L97.6,12.9L95,21l-2.6-8v-0.1h-0.1h-1.8h-0.1V13L94,23.2l-0.2,0.5c-0.6,1.7-1,2-1.7,2 c-0.6,0-1.2-0.1-1.3-0.2h-0.1v0.1l-0.2,1.2v0.1h0.1c0.6,0.2,1.1,0.2,1.8,0.2c2.1,0,2.5-1.1,3.4-3.9l3.6-10.4v-0.1h-0.1h-1.7 L97.6,12.9L97.6,12.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.8,17.2c-1.8-0.5-2.4-0.8-2.4-1.7c0-0.8,0.7-1.3,1.9-1.3c1,0,2,0.4,2.8,1.2l0.1,0.1l0.1-0.1l0.8-1v-0.1 l-0.1-0.1c-1-1-2.3-1.6-3.8-1.6c-2.3,0-3.7,1.2-3.7,3.1c0,1.6,0.9,2.5,3.3,3.1c1.8,0.5,2.3,0.8,2.3,1.7c0,0.9-0.8,1.4-2.1,1.4 c-1,0-2.1-0.5-3.1-1.3l-0.1-0.1l-0.1,0.1l-0.8,1.1v0.1l0,0c1,1.1,2.6,1.7,4.2,1.7c2.4,0,3.9-1.2,3.9-3.3 C108.1,18.7,107.2,17.8,104.8,17.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.1,21.8L114.1,21.8l-0.1-0.1c-0.3,0.1-0.5,0.2-0.9,0.2c-0.5,0-0.7-0.2-0.7-0.8v-6.7h1.6h0.1v-0.1v-1.4 v-0.1H114h-1.6V10V9.9h-0.1h-1.4h-0.1V10l-0.2,2.8l-1.2,0.3h-0.1v0.1v1.1v0.1h0.1h1.2v7c0,1.4,0.6,2.1,1.9,2.1 c0.6,0,1.3-0.1,1.8-0.3h0.1v-0.1L114.1,21.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.1,12.6c-2.9,0-4.7,2.2-4.7,5.5c0,3.4,1.7,5.4,4.8,5.4c1.5,0,2.8-0.5,3.9-1.4h0.1V22l-0.7-1.2v-0.1 l-0.1,0.1c-1.1,0.7-2,1.1-3,1.1c-2.3,0-2.9-1.7-2.9-3.2h6.8h0.1v-0.1c0-0.2,0-0.7,0-0.9C124.3,14.3,122.9,12.6,120.1,12.6  M117.4,17.1c0.1-0.6,0.4-2.9,2.8-2.9c1.5,0,2.3,1,2.3,2.9H117.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.9,12.6c-1.5,0-2.5,0.8-3.2,1.6c-0.4-1.1-1.2-1.6-2.5-1.6c-1.2,0-2.2,0.5-3.1,1.6l-0.1-1.3v-0.1h-0.1 h-1.5h-0.1v0.1v10.3v0.1h0.1h1.7h0.1v-0.1v-7.4c0.6-0.7,1.5-1.5,2.5-1.5s1.4,0.6,1.4,2.1v6.8v0.1h0.1h1.7h0.1v-0.1v-7.4 c0.6-0.7,1.4-1.4,2.4-1.4s1.4,0.6,1.4,2v6.8v0.1h0.1h1.7h0.1v-0.1v-7.1C139.7,13.8,138.7,12.6,136.9,12.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M17.1,22.8C17,23.1,17,23.1,17,23.1l7.2,2.3c0,0,0.2-0.2,0.4-0.4c0.1-0.2,0.2-0.3,0.2-0.3l-7.6-2.4 C17.2,22.4,17.2,22.6,17.1,22.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041976544197139447670000002673184266222257809_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132085851851957405440000004719417871508315798_",
    gradientUnits: "userSpaceOnUse",
    x1: -558.7468,
    y1: -342.695,
    x2: -558.4404,
    y2: -342.695,
    gradientTransform: "matrix(25.3343 0 0 -25.3343 14172.4912 -8657.9873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E62F72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1098,
    style: {
      stopColor: "#E62F72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8613,
    style: {
      stopColor: "#EC694A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC694A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22.4,
    style: {
      clipPath: "url(#SVGID_00000041976544197139447670000002673184266222257809_)",
      fill: "url(#SVGID_00000132085851851957405440000004719417871508315798_)"
    },
    width: 7.8,
    height: 3.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098222717382479632330000002046751090888846485_",
    points: "0.7,10.1 9.6,11.1 9.6,10.2 0.7,9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171696301722496260450000001872865272929005725_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098222717382479632330000002046751090888846485_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156586922669604951060000011553940657108326565_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.8045,
    y1: -341.3809,
    x2: -559.4982,
    y2: -341.3809,
    gradientTransform: "matrix(28.9794 0 0 -28.9794 16223.5 -9882.9639)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ED9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BFEB"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 9,
    style: {
      clipPath: "url(#SVGID_00000171696301722496260450000001872865272929005725_)",
      fill: "url(#SVGID_00000156586922669604951060000011553940657108326565_)"
    },
    width: 8.9,
    height: 2.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000174569951917121541660000011555776339437551504_",
    points: "0.7,16.5 0.7,17.3 9.6,16.5 9.6,15.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077291166954325434090000013647867906125638569_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174569951917121541660000011555776339437551504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130608543508958568370000016098288047688671916_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.8045,
    y1: -340.8685,
    x2: -559.4982,
    y2: -340.8685,
    gradientTransform: "matrix(28.9794 0 0 -28.9794 16223.5 -9861.6143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ED9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EC2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 15.8,
    style: {
      clipPath: "url(#SVGID_00000077291166954325434090000013647867906125638569_)",
      fill: "url(#SVGID_00000130608543508958568370000016098288047688671916_)"
    },
    width: 8.9,
    height: 1.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000082359229655484603820000001284132348070107049_",
    d: "M1.7,24.2c0,0,0.1,0.2,0.4,0.6 c0.2,0.2,0.3,0.3,0.3,0.3l7.6-3.2c0,0-0.1-0.2-0.1-0.5c-0.2-0.3-0.2-0.6-0.2-0.6L1.7,24.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059998683262859250360000015719055639793649841_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082359229655484603820000001284132348070107049_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178927385416486005030000003311228537523825315_",
    gradientUnits: "userSpaceOnUse",
    x1: -578.598,
    y1: -360.2536,
    x2: -578.2917,
    y2: -360.2536,
    gradientTransform: "matrix(12.6038 -14.0963 -14.0963 -12.6038 2218.0195 -12671.334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B61AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EC2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000059998683262859250360000015719055639793649841_)",
      fill: "url(#SVGID_00000178927385416486005030000003311228537523825315_)"
    },
    points: " -0.4,23.2 5.4,16.7 12.1,22.7 6.3,29.2  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072975142732248903570000006656384413969793447_",
    d: "M16.8,17.4c0,0,0.1,0.4,0.1,0.6s8.1-1.2,8.1-1.2 s-0.1-0.5-0.1-0.7c0,0,0,0-0.1,0C23.8,16.2,16.8,17.4,16.8,17.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168797412732620182370000006499921009983264190_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072975142732248903570000006656384413969793447_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021089873595476839540000005167017487646974343_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.7703,
    y1: -342.2018,
    x2: -559.4639,
    y2: -342.2018,
    gradientTransform: "matrix(26.841 0 0 -26.841 15041.6162 -9167.7891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520231,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7399,
    style: {
      stopColor: "#EC694A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC694A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 16.2,
    style: {
      clipPath: "url(#SVGID_00000168797412732620182370000006499921009983264190_)",
      fill: "url(#SVGID_00000021089873595476839540000005167017487646974343_)"
    },
    width: 8.2,
    height: 2.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000157299222974337175410000009919884584535411333_",
    d: "M15.9,9.6c-0.1,0.4-0.2,0.7-0.2,0.7l8.6,2.3 c0,0,0-0.2,0.1-0.5c0-0.1,0.1-0.2,0.1-0.2L16.2,9C16.2,9,16,9.2,15.9,9.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129897797242192098410000001414624330946750851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157299222974337175410000009919884584535411333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091012496352055563820000007678719037180975022_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.6643,
    y1: -341.6606,
    x2: -560.358,
    y2: -341.6606,
    gradientTransform: "matrix(28.4324 0 0 -28.4324 15956.749 -9703.4297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1619,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8497,
    style: {
      stopColor: "#FFD631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD631"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 9,
    style: {
      clipPath: "url(#SVGID_00000129897797242192098410000001414624330946750851_)",
      fill: "url(#SVGID_00000091012496352055563820000007678719037180975022_)"
    },
    width: 8.7,
    height: 3.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031182766530577229650000016705351448279257775_",
    d: "M7.9,2.8c-4.7,0-7.2,1.9-7.2,5.9v0.8l9.2,1.1h2.2 V6.1H9.7V2.7L7.9,2.8L7.9,2.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181071975454429875570000002859947784556963765_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031182766530577229650000016705351448279257775_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088130422079972732250000014320173721332849041_",
    gradientUnits: "userSpaceOnUse",
    x1: -563.573,
    y1: -337.7616,
    x2: -563.2667,
    y2: -337.7616,
    gradientTransform: "matrix(36.9328 0 0 -36.9328 20815.0273 -12467.7324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ED9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BFEB"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 2.8,
    style: {
      clipPath: "url(#SVGID_00000181071975454429875570000002859947784556963765_)",
      fill: "url(#SVGID_00000088130422079972732250000014320173721332849041_)"
    },
    width: 11.3,
    height: 7.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000108279773351103307980000016546123255167231404_",
    points: "0.7,16.9 9.6,16.2 9.6,10.7 9.6,10.6  9.9,10.6 0.7,9.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179647595428956816800000016588050923130517665_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108279773351103307980000016546123255167231404_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142894694908296858480000002124561073134759060_",
    gradientUnits: "userSpaceOnUse",
    x1: -558.1475,
    y1: -342.7358,
    x2: -557.8412,
    y2: -342.7358,
    gradientTransform: "matrix(26.5555 0 0 -26.5555 14821.8916 -9088.3213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ED9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EC2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 9.5,
    style: {
      clipPath: "url(#SVGID_00000179647595428956816800000016588050923130517665_)",
      fill: "url(#SVGID_00000142894694908296858480000002124561073134759060_)"
    },
    width: 9.2,
    height: 7.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059267636151434387110000013736406280082608545_",
    d: "M2.1,24.8c1.4,2,3.6,3.2,6.3,3.7c0,0,5-1.2,6.5-4.3 c-0.3,0.1-1,0.1-1.4,0.1c-2.3,0-3.3-1.2-3.8-2.8L2.1,24.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011743311057861888570000012118129199084503202_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059267636151434387110000013736406280082608545_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133492047903829730370000011691663333417664135_",
    gradientUnits: "userSpaceOnUse",
    x1: -543.0883,
    y1: -327.978,
    x2: -542.782,
    y2: -327.978,
    gradientTransform: "matrix(15.9616 12.1308 12.1308 -15.9616 12653.8701 1376.5751)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B61AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#164193"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011743311057861888570000012118129199084503202_)",
      fill: "url(#SVGID_00000133492047903829730370000011691663333417664135_)"
    },
    points: " 6.8,15.2 18.3,24 10.3,34.7 -1.3,25.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000058572177511161166350000005623362291415015054_",
    d: "M0.7,16.9v3.2c0,1.9,0.5,3.5,1.4,4.7l7.7-3.3 c-0.2-0.7-0.2-1.6-0.2-2.4v-2.9L0.7,16.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108275689721643275330000010079006511989915288_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058572177511161166350000005623362291415015054_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042713408021384358430000000934080722328540808_",
    gradientUnits: "userSpaceOnUse",
    x1: -578.262,
    y1: -350.0976,
    x2: -577.9556,
    y2: -350.0976,
    gradientTransform: "matrix(17.6351 -19.7235 -19.7235 -17.6351 3295.0139 -17555.6738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B61AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007EC2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000108275689721643275330000010079006511989915288_)",
      fill: "url(#SVGID_00000042713408021384358430000000934080722328540808_)"
    },
    points: " -3.5,21 4.8,11.7 14.1,20 5.8,29.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005957230594968058040000018289886910673517199_",
    d: "M21.4,6.1c-2.8,0-4.8,1.4-5.5,3.5l8.5,2.5 c0.3-1.1,1.3-1.5,2.7-1.5V6.1H21.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106843983964405696810000003266461301598519211_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005957230594968058040000018289886910673517199_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047058161950219048000000006855432853022865537_",
    gradientUnits: "userSpaceOnUse",
    x1: -564.3522,
    y1: -337.7784,
    x2: -564.0458,
    y2: -337.7784,
    gradientTransform: "matrix(36.4954 0 0 -36.4954 20612.1602 -12318.2559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1619,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8497,
    style: {
      stopColor: "#FFD631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD631"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 6.1,
    style: {
      clipPath: "url(#SVGID_00000106843983964405696810000003266461301598519211_)",
      fill: "url(#SVGID_00000047058161950219048000000006855432853022865537_)"
    },
    width: 11.2,
    height: 6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062883352264132124810000000262496028590534325_",
    d: "M15.8,12.8c0.4,1.9,0.8,3.4,1.1,4.9l8.1-1.2 c-0.3-1.4-0.6-2.7-0.6-3c-0.1-0.6-0.1-1,0-1.4l-8.5-2.5C15.6,10.6,15.5,11.7,15.8,12.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127731456843985289130000015988125174825391790_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062883352264132124810000000262496028590534325_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177447984833154066330000016831682484104803261_",
    gradientUnits: "userSpaceOnUse",
    x1: -561.8172,
    y1: -340.1906,
    x2: -561.5109,
    y2: -340.1906,
    gradientTransform: "matrix(30.5656 0 0 -30.5656 17187.8867 -10384.4775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520231,
    style: {
      stopColor: "#F8B133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7399,
    style: {
      stopColor: "#EC694A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC694A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 9.6,
    style: {
      clipPath: "url(#SVGID_00000127731456843985289130000015988125174825391790_)",
      fill: "url(#SVGID_00000177447984833154066330000016831682484104803261_)"
    },
    width: 9.5,
    height: 8.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003808562646140379420000001602281668995939970_",
    d: "M11.4,28.4l0.1,0.3c0.3,0,1.1,0,2.8,0 c3.9,0,8.2-0.9,10.2-3.8L17,22.7C16.6,25.3,14.8,27.2,11.4,28.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047049523498837651270000014146034538676745347_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003808562646140379420000001602281668995939970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002373756593949233530000010647796573859801279_",
    gradientUnits: "userSpaceOnUse",
    x1: -590.0789,
    y1: -346.9878,
    x2: -589.7726,
    y2: -346.9878,
    gradientTransform: "matrix(6.8759 -23.9024 -23.9024 -6.8759 -4220.0908 -16458.6934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2006B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    style: {
      stopColor: "#E62F72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E62F72"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047049523498837651270000014146034538676745347_)",
      fill: "url(#SVGID_00000002373756593949233530000010647796573859801279_)"
    },
    points: " 9.9,28.4 12.5,19.3 26.2,23.3 23.6,32.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000172403250922139048820000012271209432173922188_",
    d: "M16.9,17.7c0.2,1.2,0.4,2.4,0.4,3.8 c0,0.5,0,0.9-0.1,1.4l7.5,2.2c0.7-1,1.1-2.2,1.1-3.7c0-1.1-0.4-3.1-0.7-4.9L16.9,17.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099637313568255601500000015254607653514647169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172403250922139048820000012271209432173922188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030457155148916870820000018225999514751060667_",
    gradientUnits: "userSpaceOnUse",
    x1: -563.8497,
    y1: -345.4606,
    x2: -563.5432,
    y2: -345.4606,
    gradientTransform: "matrix(25.7551 -5.6134 -5.6134 -25.7551 12600.127 -12040.8203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E62F72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1098,
    style: {
      stopColor: "#E62F72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8613,
    style: {
      stopColor: "#EC694A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC694A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000099637313568255601500000015254607653514647169_)",
      fill: "url(#SVGID_00000030457155148916870820000018225999514751060667_)"
    },
    points: " 15.1,16.9 25.3,14.7 27.5,24.7 17.3,26.9  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M194.5,26.9c0-4.1,0-8.1,0-12.2c0-0.3,0.1-0.4,0.4-0.4c0.5,0,1,0,1.5,0c0.3,0,0.5,0,0.5,0.4 c0.5-0.2,0.9-0.5,1.4-0.6c1.9-0.3,3.5,0.5,3.9,2.6c0.2,1.2,0.3,2.5,0,3.7c-0.3,1.9-1.4,2.8-3.4,2.9c-0.5,0-1.1,0-1.6-0.1 c-0.2,0-0.4-0.1-0.4,0.3c0,1.1-0.1,2.2,0,3.4C196.1,26.9,195.3,26.9,194.5,26.9z M196.8,18.9c0,0.7,0,1.3,0,2 c0,0.3,0.1,0.4,0.3,0.4c0.4,0,0.8,0.1,1.2,0c0.8-0.1,1.2-0.4,1.4-1.2c0.2-0.8,0.2-1.6,0.1-2.5c-0.2-1.1-0.8-1.6-1.9-1.4 c-0.3,0-0.5,0.1-0.7,0.2c-0.3,0.1-0.4,0.2-0.4,0.5C196.8,17.6,196.8,18.2,196.8,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M218.7,16.9c0,1.9,0,3.8,0,5.7c0,0.3-0.1,0.5-0.4,0.5c-0.4,0-0.9,0-1.3,0c-0.2,0-0.5,0.1-0.6-0.2 c-0.1-0.2-0.3,0-0.4,0.1c-0.9,0.4-1.8,0.5-2.7,0.3c-1.1-0.2-1.8-0.8-2.1-1.9c-0.5-1.6-0.5-3.3,0-4.9c0.5-1.8,2-2.4,3.7-2.3 c0.4,0,0.8,0.1,1.1,0.2c0.4,0.1,0.5-0.1,0.5-0.4c0-0.9,0-1.8,0-2.7c0-0.3,0.1-0.4,0.4-0.4c0.5,0,1,0,1.6,0c0.3,0,0.4,0.1,0.4,0.4 C218.7,13.1,218.7,15,218.7,16.9z M216.3,18.6c0-0.3,0-0.7,0-1c0-1.5,0-1.5-1.6-1.5c-0.7,0-1.1,0.2-1.3,0.9 c-0.4,1.1-0.3,2.3,0,3.4c0.1,0.4,0.4,0.7,0.8,0.7c0.6,0,1.2,0,1.8-0.2c0.2-0.1,0.3-0.2,0.3-0.4C216.3,20,216.3,19.3,216.3,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M192.5,16.5c-1.2-0.1-2.2-0.3-3.3-0.3c-0.7,0-1.2,0.2-1.2,0.6c0,0.7,0.6,0.6,1,0.7c0.7,0.2,1.5,0.2,2.3,0.5 c1,0.4,1.5,1,1.5,2.1c0,0.8,0,1.5-0.6,2.2s-1.5,0.9-2.4,1c-1.2,0.1-2.5-0.1-3.7-0.3c-0.3,0-0.4-0.2-0.3-0.4c0-0.4,0-0.8,0-1.1 c-0.1-0.5,0.2-0.5,0.6-0.4c1,0.2,2,0.2,2.9,0.2c0.7,0,1-0.2,1.1-0.6c0-0.6-0.5-0.6-0.9-0.7c-0.7-0.2-1.4-0.2-2.1-0.4 c-1.3-0.4-1.7-1-1.8-2.2c-0.1-1.3,0.5-2.2,1.5-2.7c1.1-0.5,2.2-0.4,3.3-0.3c0.6,0.1,1.1,0.2,1.7,0.3c0.2,0,0.4,0.1,0.4,0.4 C192.4,15.4,192.5,15.9,192.5,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M204,16.8c0-1.5,1.1-2.5,2.6-2.4c1.4,0,2.5,1.1,2.4,2.6c0,1.5-1.1,2.5-2.6,2.5C205,19.4,204,18.3,204,16.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M206.5,23c-0.7,0-1.4,0-2,0c-0.5,0-0.5-0.2-0.4-0.5c0.1-1,0.9-1.8,2.1-2c1.1-0.2,2.1,0.3,2.6,1.3 c0.5,1.1,0.4,1.3-0.7,1.3C207.5,23,207,23,206.5,23L206.5,23z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 174.6,
    y1: 0.5,
    x2: 174.6,
    y2: 29.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidIdpTeamsystemid);
export default __webpack_public_path__ + "static/media/spid-idp-teamsystemid.712e7dbff03097c95bafcb0f39d2d7ba.svg";
export { ForwardRef as ReactComponent };